import Point from './Utility/Point';

export const SETTINGS: IGameSettings = {
    maxSpinWheelCount: 2,
    canvasSize: new Point(1352, 760),
};

export interface IGameSettings {
    maxSpinWheelCount: number;
    canvasSize: Point;
    [key: string]: any;
}
